import httpClient from '@/api/httpClient'

// ドキュメント名 IO 一覧取得
class IOApi {
  // advertiserId に紐づく IO のリストを取得する
  // 主に StandardReportApi の最初の IO の一覧を取得するために必要

  // + period:`all` (string, require) - all, now, recentlyのいずれか
  // + period (object, require) - BPが含まれる期間
  //    + startDate: `2018-10-01` (string, require) - 期間の開始日
  //    + endDate: `2018-10-02` (string, require) - 期間の終了日
  static async fetchIOList({
    advertiserId, // 必須
    keyword,
    minPermissionLevel,
    IOIds,
    period = 'all',
    isIncludeDeleted = null,
    withoutUnrequestedBudget = true,
    ioStatuses = ['active', 'inactive'],
    pageNo,
    pageSize,
    sortKey = 'id',
    sortDirection = 'desc',
  }) {
    if (ioStatuses.length === 0) return { items: [], count: 0, pageNo: 1 }
    const status = (() => {
      if (ioStatuses.includes('active') && ioStatuses.includes('inactive'))
        return undefined
      if (ioStatuses.includes('active') || ioStatuses.includes('inactive'))
        return ioStatuses[0]
      return undefined
    })()
    const reqBody = {
      query: {
        advertiserId: Number(advertiserId),
        keyword,
        minPermissionLevel,
        insertionOrder: {
          ids: IOIds,
        },
        billingPeriod: {
          period,
        },
        isIncludeDeleted,
        withoutUnrequestedBudget,
        status,
      },
      sortKey,
      sortDirection,
    }
    if (pageNo === undefined && pageSize === undefined) {
      const res = await httpClient.post(`/insertion_order/search/all`, {
        ...reqBody,
      })
      return res.data
    }
    const res = await httpClient.post(`/insertion_order/search`, {
      ...reqBody,
      pageNo,
      pageSize,
    })
    return res.data
  }

  /**
   * 案件予算一覧を取得する。
   *
   * @param {Object} params
   * @param {number} params.IOId - Insertion Order ID
   */
  static async fetchIOBudgetList({ IOId, campaignId }) {
    const res = await httpClient.get(`/insertion_order/${IOId}/budget`, {
      params: { campaignId },
    })
    return res.data
  }

  static async fetchIOBudget({ insertionOrderId, insertionOrderBudgetId }) {
    const res = await httpClient.get(
      `/insertion_order/${insertionOrderId}/budget/${insertionOrderBudgetId}`,
    )
    return res.data
  }

  static async deleteIOBudget({ insertionOrderId, insertionOrderBudgetId }) {
    await httpClient.delete(
      `/insertion_order/${insertionOrderId}/budget/${insertionOrderBudgetId}`,
    )
  }

  /**
   * 案件登録
   * @param {Object} params
   * @param {string} params.name - 案件名（必須）
   * @param {string} params.code - コード
   * @param {number} params.advertiserId - 広告主ID
   * @param {number} params.agencyMarginId - 代理店マージンID
   * @param {string} params.note - メモ
   * @param {number} params.salesAccountId - 担当営業名
   */
  static async postIO({
    name,
    code,
    advertiserId,
    agencyMarginId,
    note,
    salesAccountId,
  }) {
    const res = await httpClient.post(`/insertion_order`, {
      name,
      code,
      advertiserId,
      agencyMarginId,
      note,
      salesAccountId,
    })
    return res.data
  }

  /**
   * 案件編集
   * @param {Object} params
   * @param {number} params.id - 案件ID
   * @param {string} params.name - 案件名（必須）
   * @param {string} params.code - コード
   * @param {string} params.status - ステータス（必須）
   * @param {number} params.agencyMarginId - 代理店マージンID
   * @param {string} params.note - メモ
   * @param {number} params.salesAccountId - 担当営業名
   */
  static async putIO({
    id,
    name,
    code,
    status,
    agencyMarginId,
    note,
    salesAccountId,
  }) {
    const res = await httpClient.put(`/insertion_order/${id}`, {
      name,
      code,
      status,
      agencyMarginId,
      note,
      salesAccountId,
    })
    return res.data
  }

  /**
   * 案件削除
   * @param {Object} params
   * @param {number} params.id - 案件ID
   */
  static async deleteIO({ id }) {
    const res = await httpClient.delete(`/insertion_order/${id}`)
    return res.data
  }

  static async fetchMenuList(insertionOrderId, params) {
    const res = await httpClient.get(
      `/insertion_order/${insertionOrderId}/menu`,
      {
        params,
      },
    )
    return res.data
  }

  static async fetchSalesAccountList(params, insertionOrderId) {
    const res = await httpClient.get(
      `/insertion_order/${insertionOrderId}/account`,
      { params: params },
    )
    return res.data
  }
}

export default IOApi
